module.exports = __webpack_public_path__ + "img/frenchpolynesia.c1e0ba5b.svg";